<script setup>
import { h } from 'vue'

import { isFirefox, isMacOs, isSafari } from '@/utils/general'
import {
  AZURE_WORK_ITEM_ICON,
  BASE64_JIRA_CLOUD_JIRA_ICONS,
  NO_JIRA_ISSUE_TYPE_ICON
} from '@/utils/roadmap'

/**
 * @name TaskIconForExport
 * @description Render all our base64 Jira icons in the hidden div for export to PDF.
 * Coz Safari and some versions of Firefox can't render base64 images in the PDF
 * if they are not rendered on the page.
 */

defineOptions({
  name: 'TaskIconForExport'
})

const IconsNode = () => {
  if (isMacOs() && (isSafari() || isFirefox())) {
    return h(
      'div',
      {
        style: {
          display: 'none'
        }
      },
      [
        ...Object.values(BASE64_JIRA_CLOUD_JIRA_ICONS),
        NO_JIRA_ISSUE_TYPE_ICON,
        AZURE_WORK_ITEM_ICON
      ].map((item, index) =>
        h('img', {
          key: index,
          src: item
        })
      )
    )
  }
}
</script>

<template>
  <IconsNode />
</template>
